
import { mapActions, mapMutations } from 'vuex';
import formValidation from "@/mixins/formValidation";
import checkboxManagerMixin from '@/mixins/checkboxManager';

export default {
	mixins: [formValidation, checkboxManagerMixin],
	props: {
		catalog: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			selectedMarkObject: null,
		};
	},
	computed: {
		availableModels() {
			if (this.selectedMarkObject && this.selectedMarkObject.models) {
				return this.selectedMarkObject.models;
			}
			return [];
		},
		mark_valid() {
			return this.selectedMarkObject &&
				   this.selectedMarkObject.title.toLowerCase() === this.form.mark.value.toLowerCase();
		},
		model_valid() {
			return this.form.model.value && this.availableModels.some(
				model => model.title.toLowerCase() === this.form.model.value.toLowerCase()
			);
		},
	},
	watch: {
		'form.mark.value'(newValue) {
			if (newValue === '') {
				this.selectedMarkObject = null;
				this.form.model.value = '';
			}
		}
	},
	methods: {
		...mapActions({
			sendForm: 'form/form/sendForm'
		}),
		...mapMutations({
			setFocusShowFixes: 'car/car/SET_FOCUS_SHOW_FIXED'
		}),
		onMarkSelected(markObject) {
			this.selectedMarkObject = markObject;
			this.form.model.value = '';
		},
		onMarkBlur() {
			this.onFocusOut();
			setTimeout(() => {
				if (this.form.mark.value && !this.mark_valid) {
					this.form.mark.valid = false;
					this.form.mark.value = '';
                    this.selectedMarkObject = null;
				}
			}, 200);
		},
		onModelBlur() {
			this.onFocusOut();
			setTimeout(() => {
				if (this.form.model.value && !this.model_valid) {
					this.form.model.valid = false;
					this.form.model.value = '';
				}
			}, 200);
		},
		onFocus() {
			this.setFocusShowFixes(false)
		},
		onFocusOut() {
			setTimeout(() => {
				this.setFocusShowFixes(true)
			}, 1000)
		},
		checkForm() {
			if (!this.mark_valid) {
				this.form.mark.valid = false;
				this.form.mark.value = '';
				return false;
			}
			if (!this.model_valid) {
				this.form.model.valid = false;
				this.form.model.value = '';
				return false;
			}
			if (this.form.year.value === 'Год' || !this.form.year.value) {
				this.form.year.valid = false;
				return false;
			}
			if (this.form.run.value.length < 1) {
				this.form.run.valid = false;
				return false;
			}
			if (this.form.name.value.length < 2) {
				this.form.name.valid = false;
				return false;
			}
			if (!this.form.phone.valid) {
				this.form.phone.valid = false;
				return false;
			}
			const checkboxesValid = this.validateCheckboxes();
			if (!checkboxesValid) {
				return false;
			}
			return true;
		},
		async submitForm() {
			if (this.checkForm()) {
				let formData = {
					type: 'buyout',
					client_name: this.form.name.value,
					client_phone: this.form.phone.value,
					client_vehicle_mark: this.form.mark.value,
					client_vehicle_model: this.form.model.value,
					client_vehicle_run: this.form.run.value,
					client_vehicle_year: '' + this.form.year.value,
				}
				if (localStorage.utm_source) {
					formData.utm_source = localStorage.utm_source
				}
				if (localStorage.utm_medium) {
					formData.utm_medium = localStorage.utm_medium
				}
				if (localStorage.utm_campaign) {
					formData.utm_campaign = localStorage.utm_campaign
				}
				if (localStorage.utm_term) {
					formData.utm_term = localStorage.utm_term
				}
				if (localStorage.utm_content) {
					formData.utm_content = localStorage.utm_content
				}
				await this.sendForm(formData)
			}
		}
	},
};
